import { createTheme } from "@mui/material";

const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#111008", // ink
      contrastText: "#fefcf7",
    },
    secondary: {
      main: "#b07d2a", // gold
      contrastText: "#fefcf7",
    },
    background: {
      default: "#f9f6ef", // cream
      default50: "#ffb30090", // cream
      paper: "#fefcf7", // white
    },
    text: {
      primary: "#111008",
      secondary: "#7a7668",
      third: "#b07d2a",
    },
    success: {
      main: "#2d6644",
      contrastText: "#fefcf7",
    },
    error: {
      main: "#e74c3c",
      contrastText: "#fefcf7",
    },
    //customDivider: "#d8d1c7",
    customDivider: "#e0e0e0",
    offWhite: "#fefcf7",
    grey: {
      50: "#fefcf7",
      100: "#f9f6ef",
      200: "#f2ede2",
      300: "#e8e2d5",
      400: "#dddad2",
      500: "#b8b4a8",
      600: "#7a7668",
      700: "#3d3a30",
      900: "#111008",
    },
  },

  typography: {
    fontFamily: '"Outfit", sans-serif',
    h1: {
      fontFamily: '"Playfair Display", Georgia, serif',
      fontWeight: 700,
      fontSize: "4.25rem",
      lineHeight: 1.05,
      letterSpacing: "-0.02em",
    },
    h2: {
      fontFamily: '"Playfair Display", Georgia, serif',
      fontWeight: 700,
      fontSize: "3rem",
      lineHeight: 1.1,
      letterSpacing: "-0.02em",
    },
    h3: {
      fontFamily: '"Playfair Display", Georgia, serif',
      fontWeight: 700,
      fontSize: "2rem",
      lineHeight: 1.15,
      letterSpacing: "-0.02em",
    },
    h4: {
      fontFamily: '"Playfair Display", Georgia, serif',
      fontWeight: 700,
      fontSize: "1.5rem",
      lineHeight: 1.2,
    },
    h5: {
      fontFamily: '"Playfair Display", Georgia, serif',
      fontWeight: 700,
      fontSize: "1.25rem",
      lineHeight: 1.25,
    },
    h6: {
      fontFamily: '"Playfair Display", Georgia, serif',
      fontWeight: 700,
      fontSize: "1.125rem",
      lineHeight: 1.3,
    },
    subtitle1: {
      fontFamily: '"Outfit", sans-serif',
      fontWeight: 500,
      fontSize: "1rem",
      lineHeight: 1.6,
      color: "#3d3a30",
    },
    subtitle2: {
      fontFamily: '"Outfit", sans-serif',
      fontWeight: 500,
      fontSize: "0.875rem",
      lineHeight: 1.5,
      color: "#7a7668",
    },
    body1: {
      fontFamily: '"Outfit", sans-serif',
      fontWeight: 300,
      fontSize: "1rem",
      lineHeight: 1.7,
      color: "#111008",
    },
    body2: {
      fontFamily: '"Outfit", sans-serif',
      fontWeight: 400,
      fontSize: "0.875rem",
      lineHeight: 1.6,
      color: "#3d3a30",
    },
    button: {
      fontFamily: '"Outfit", sans-serif',
      fontWeight: 600,
      fontSize: "0.875rem",
      lineHeight: 1.2,
      textTransform: "none",
    },
    caption: {
      fontFamily: '"Outfit", sans-serif',
      fontWeight: 400,
      fontSize: "0.75rem",
      lineHeight: 1.5,
      color: "#7a7668",
    },
    overline: {
      fontFamily: '"Outfit", sans-serif',
      fontWeight: 600,
      fontSize: "0.6875rem",
      lineHeight: 1.4,
      letterSpacing: "0.14em",
      textTransform: "uppercase",
      color: "#b07d2a",
    },
  },

  shape: {
    borderRadius: 10,
  },

  spacing: 8,

  shadows: [
    "none",
    "0 2px 8px rgba(17,16,8,0.04)",
    "0 4px 12px rgba(17,16,8,0.06)",
    "0 8px 24px rgba(17,16,8,0.08)",
    "0 12px 32px rgba(17,16,8,0.10)",
    "0 16px 48px rgba(17,16,8,0.12)",
    "0 20px 56px rgba(17,16,8,0.14)",
    "0 24px 64px rgba(17,16,8,0.16)",
    "0 28px 72px rgba(17,16,8,0.18)",
    "0 32px 80px rgba(17,16,8,0.20)",
    "0 36px 88px rgba(17,16,8,0.22)",
    "0 40px 96px rgba(17,16,8,0.24)",
    "0 44px 104px rgba(17,16,8,0.26)",
    "0 48px 112px rgba(17,16,8,0.28)",
    "0 52px 120px rgba(17,16,8,0.30)",
    "0 56px 128px rgba(17,16,8,0.32)",
    "0 60px 136px rgba(17,16,8,0.34)",
    "0 64px 144px rgba(17,16,8,0.36)",
    "0 68px 152px rgba(17,16,8,0.38)",
    "0 72px 160px rgba(17,16,8,0.40)",
    "0 76px 168px rgba(17,16,8,0.42)",
    "0 80px 176px rgba(17,16,8,0.44)",
    "0 84px 184px rgba(17,16,8,0.46)",
    "0 88px 192px rgba(17,16,8,0.48)",
    "0 92px 200px rgba(17,16,8,0.50)",
  ],

  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: "#f9f6ef",
          color: "#111008",
        },
        "*": {
          boxSizing: "border-box",
        },
        ".phone-input-wrapper": {
          display: "flex",
          flexDirection: "column",
          gap: "8px",
        },

        ".phone-input-label": {
          fontFamily: '"Outfit", sans-serif',
          fontWeight: 600,
          fontSize: "0.6875rem",
          letterSpacing: "0.08em",
          textTransform: "uppercase",
          color: "#7a7668",
        },

        ".PhoneInput": {
          display: "flex",
          alignItems: "center",
          width: "100%",
          borderRadius: "10px",
          backgroundColor: "#f9f6ef",
          border: "1.5px solid #e8e2d5",
          transition: "border-color 0.2s ease",
          boxSizing: "border-box",
        },

        ".PhoneInput:hover": {
          borderColor: "#b8b4a8",
        },

        ".PhoneInput:focus-within": {
          borderColor: "#111008",
        },

        ".PhoneInputCountry": {
          display: "flex",
          alignItems: "center",
          paddingLeft: "14px",
          paddingRight: "8px",
          marginRight: "0px",
        },

        ".PhoneInputCountrySelect": {
          border: "none",
          background: "transparent",
          fontSize: "0.875rem",
          fontFamily: '"Outfit", sans-serif',
          color: "#111008",
          outline: "none",
          cursor: "pointer",
        },

        ".PhoneInputCountryIcon": {
          width: "20px",
          height: "14px",
          boxShadow: "none",
        },

        ".PhoneInputInput": {
          flex: 1,
          border: "none",
          outline: "none",
          background: "transparent",
          fontSize: "0.875rem",
          fontWeight: 500,
          padding: "12px 14px 12px 6px",
          fontFamily: '"Outfit", sans-serif',
          color: "#111008",
          minWidth: 0,
        },

        ".PhoneInputInput::placeholder": {
          color: "#7a7668",
          opacity: 1,
        },
      },
    },

    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          padding: "9px 20px",
          fontWeight: 600,
          boxShadow: "none",
        },
        containedPrimary: {
          backgroundColor: "#111008",
          color: "#fefcf7",
          "&:hover": {
            backgroundColor: "#3d3a30",
            boxShadow: "none",
          },
        },
        containedSecondary: {
          backgroundColor: "#b07d2a",
          color: "#fefcf7",
          "&:hover": {
            backgroundColor: "#d4a040",
            boxShadow: "none",
          },
        },
        outlinedPrimary: {
          borderColor: "#111008",
          color: "#111008",
          "&:hover": {
            backgroundColor: "#111008",
            color: "#fefcf7",
            borderColor: "#111008",
          },
        },
        textPrimary: {
          color: "#3d3a30",
          "&:hover": {
            backgroundColor: "rgba(17,16,8,0.04)",
          },
        },
        sizeLarge: {
          padding: "14px 32px",
          borderRadius: 18,
          fontSize: "0.9375rem",
        },
      },
    },

    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: "#fefcf7",
          border: "1px solid #e8e2d5",
          borderRadius: 28,
          boxShadow: "0 16px 48px rgba(17,16,8,0.08)",
        },
      },
    },

    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: "none",
        },
        rounded: {
          borderRadius: 18,
        },
      },
    },

    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: "rgba(249,246,239,0.92)",
          color: "#111008",
          boxShadow: "none",
          borderBottom: "1px solid #e8e2d5",
          backdropFilter: "blur(16px)",
        },
      },
    },

    MuiToolbar: {
      styleOverrides: {
        root: {
          height: "64px",
        },
      },
    },

    MuiTypography: {
      defaultProps: {
        color: "text.primary",
      },
    },

    MuiTextField: {
      defaultProps: {
        variant: "outlined",
      },
    },

    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          backgroundColor: "#f9f6ef",
          fontWeight: 500,
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#e8e2d5",
            borderWidth: "1.5px",
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#b8b4a8",
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#111008",
          },
        },
        input: {
          fontSize: "0.875rem",
          padding: "12px 14px",
        },
      },
    },

    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontFamily: '"Outfit", sans-serif',
          fontWeight: 600,
          fontSize: "0.6875rem",
          letterSpacing: "0.08em",
          textTransform: "uppercase",
          color: "#7a7668",
        },
      },
    },

    MuiDivider: {
      styleOverrides: {
        root: {
          borderColor: "#e8e2d5",
        },
      },
    },

    MuiLink: {
      styleOverrides: {
        root: {
          color: "#111008",
          textDecoration: "none",
          "&:hover": {
            color: "#3d3a30",
          },
        },
      },
    },

    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          fontFamily: '"Outfit", sans-serif',
          fontWeight: 400,
          //padding: "10px",
          fontSize: "0.75rem",
        },
      },
    },

    MuiAlert: {
      styleOverrides: {
        root: ({ ownerState, theme }) => ({
          ...(ownerState.severity === "error" && {
            backgroundColor: `${theme.palette.error.main}20`,
            color: theme.palette.error.main,
            "& .MuiAlert-icon": {
              color: theme.palette.error.main,
            },
          }),
          ...(ownerState.severity === "success" && {
            backgroundColor: `${theme.palette.success.main}20`,
            color: theme.palette.success.main,
            "& .MuiAlert-icon": {
              color: theme.palette.success.main,
            },
          }),
          ...(ownerState.severity === "warning" && {
            backgroundColor: `${theme.palette.warning.main}20`,
            color: theme.palette.warning.main,
            "& .MuiAlert-icon": {
              color: theme.palette.warning.main,
            },
          }),
          ...(ownerState.severity === "info" && {
            backgroundColor: `${theme.palette.info.main}20`,
            color: theme.palette.info.main,
            "& .MuiAlert-icon": {
              color: theme.palette.info.main,
            },
          }),
        }),
      },
    },
    MuiChip: {
      styleOverrides: {
        root: ({ ownerState, theme }) => ({
          borderRadius: 20,
          fontWeight: 500,
          fontSize: "0.75rem",

          // default (no color prop)
          backgroundColor: "#f2ede2",
          color: "#3d3a30",

          ...(ownerState.color === "primary" && {
            backgroundColor: `${theme.palette.primary.main}20`,
            color: theme.palette.primary.main,
          }),
          ...(ownerState.color === "success" && {
            backgroundColor: `${theme.palette.success.main}20`,
            color: theme.palette.success.main,
          }),
          ...(ownerState.color === "error" && {
            backgroundColor: `${theme.palette.error.main}20`,
            color: theme.palette.error.main,
          }),
          ...(ownerState.color === "info" && {
            backgroundColor: `${theme.palette.info.main}20`,
            color: theme.palette.info.main,
          }),
        }),
      },
    },
  },
});

export default theme;
